import { isEmpty } from 'ramda'
import { useIntl } from '@/intl'
import { AccoList } from '@/scopes/common/components/AccoLister/AccoList'
import { AccoListLoading } from '@/scopes/common/components/AccoLister/AccoList/AccoListLoading'
import SectionTitle from '@/scopes/destinations/components/SectionTitle'
import { useDestinationTitleValues } from '@/scopes/destinations/components/useDestinationTitleValues'
import { popularAccosSelector } from '@/scopes/destinations/domain/selectors'
import { useDestinationStoreSelector } from '@/scopes/destinations/infrastructure/store/useDestinationStoreSelector'

const MIN_NUMBER_OF_RESULTS_TO_SHOW_CONTROLS = 2

export function DestinationAccoLister() {
  const intl = useIntl()
  const { results, isLoading, error } = useDestinationStoreSelector(popularAccosSelector)
  const destinationTitleValues = useDestinationTitleValues({ shouldUseSpecialPreposition: false })
  const title = <SectionTitle>{intl.formatMessage({ id: 'destination_popular_accos' }, destinationTitleValues)}</SectionTitle>

  if (isLoading) {
    return (
      <section>
        {title}
        <AccoListLoading />
      </section>
    )
  }

  if (error || isEmpty(results)) {
    return null
  }

  return (
    <section>
      {title}
      <AccoList
        accos={results}
        hasControls={results.length > MIN_NUMBER_OF_RESULTS_TO_SHOW_CONTROLS}
        nextButtonLabel={intl.formatMessage({ id: 'destination_popular_next_label' })}
        prevButtonLabel={intl.formatMessage({ id: 'destination_popular_prev_label' })}
      />
    </section>
  )
}
